// extracted by mini-css-extract-plugin
export default {"container":"nl-z","freeShip":"ol-z","privacy":"pl-z"};